<template>
  <div class="client-details">
    <portal to="sidebar-menu">

      <div>
        <nav-back-button to="/contacts/users">
          {{$t('user.details.menu.back')}}
        </nav-back-button>

        <card type="user" plain footer-classes="p-0" class="mb-0 px-2">
          <div class="d-flex flex-column" v-if="user.uuid">
            <div class="d-flex text-overflow align-items-center">
              <base-avatar :src="user.image" :user="user" :circle="false" size="sm" alt="User avatar"/>
              <div class="ml-2">
                <el-tooltip v-if="user.given_name && user.family_name" :content="`${user.given_name} ${user.family_name}`" placement="top-start">
                  <div class="font-weight-bold mb-0 text-overflow">{{user.given_name}} {{user.family_name}}</div>
                </el-tooltip>
                <div class="d-flex align-items-center text-overflow" v-if="user.email">
                  <i class="nc-icon nc-email-85"></i>&nbsp;
                  <el-tooltip :content="user.email" placement="top-start">
                    <div class="description">{{user.email}}</div>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>

          <template slot="footer">
            <hr class="mb-0">
            <div class="button-container" v-if="clientCount > 0">
              <div class="d-flex flex-column mt-3">
                <div class="d-flex justify-content-between h6 mb-0">
                  <small class="mb-2">{{$t('generic.clients')}}</small>
                  <span>{{clientCount}}</span>
                </div>
              </div>
            </div>
          </template>
        </card>

        <nav-list :items="navigationItems"
                  @on-delete-click="deleteUser">
        </nav-list>
      </div>

    </portal>

    <div class="row">
      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import { entities } from 'src/config/routeTypes'
  import NavList from 'src/components/List/NavList'
  import UserService from 'src/services/UserService'
  import { getRouteName, routeTypes } from 'src/config/routeTypes'

  export default {
    name: 'user-details',
    components: {
      NavList,
      UserService
    },
    data () {
      return {
        user: {},
        error: null,
        deleteActive: false,
        navigationItems: [
          {
            type: 'group',
            name: this.$t('generic.settings')
          },
          {
            routeName: 'user_dashboard',
            name: this.$t('user.details.menu.overview')
          },
          {
            routeName: 'user_edit',
            name: this.$t('user.details.menu.edit'),
            hide: !this.$can('admin-users-crud')
          },
          {
            routeName: 'user_logs',
            name: this.$t('user.details.menu.logs'),
            hide: !this.$can('admin-wip')
          },
          {
            name: this.$t('generic.delete.title'),
            hide: !this.$can('admin-users-crud'),
            title: 'delete'
          }
        ]
      }
    },
    computed: {
      clientCount () {
        let clientCount = this.$store.state.user.userClientCount
        if (clientCount === -1) {
          return this.$t('generic.na')
        }
        return `${clientCount} `
      },
    },
    methods: {
      async deleteUser () {
        let msg = this.$t('user.details.delete.confirm', {msg: this.user.given_name})
        await this.$confirm(msg)
        await UserService.delete(this.user.uuid)
        this.$router.push({name: getRouteName(routeTypes.LIST, entities.USER)})
      }
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await UserService.getById(id)
        let user = res.data
        if (user) {
          next(vm => {
            vm.user = user
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    },
  }
</script>
<style lang="scss">
  .client-details {
    .client-image {
      width: 100px;
      height: 100%;
    }
    .card__info {
      margin-top: 10px;
      margin-left: 65px;
      display: flex;
      align-items: center;
    }
  }
</style>
